import React, { useState, useEffect } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { Modal } from "react-bootstrap";
import DataTable from "./DataTable/DataTable";
import "../AllClaim/claim.scss";

import { Api_Url } from "../../../utils/ApiUrl";
import axios from "axios";
import { useWeb3React } from "@web3-react/core";
import CuurentRound from "../../../hooks/dataFetchers/round";

const LeadersAdmin = ({ tomiPrice, usdPrice, btcPrice, user }) => {
  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);
  const [show3, setShow3] = useState(false);
  const handleClose3 = () => setShow3(false);

  const [claimsData, setClaimsData] = useState([]);
  const [rend, setRend] = useState(false);
  // const [usdPrice, setUsdPrice] = useState(0);
  const { cuurentRound } = CuurentRound();
  const { account } = useWeb3React();
  const tok = localStorage.getItem("accessToken");
  const [loaderr, setLoarder] = useState(false);
  // // console.log('tererererer', claimsData)
  const getClaimsData = () => {
    var config = {
      method: "get",
      url: `${Api_Url}/users/my-claims?limit=2000&offset=1`,

      headers: {
        Authorization: "Bearer " + tok,
      },
    };

    // let dynamicQuery = config.url;
    // if (round) {
    //     dynamicQuery += `&round=${round}`;
    // }
    // if (search) {
    //     dynamicQuery += `&search=${search}`;
    // }

    // if (typeFilter) {
    //     dynamicQuery += `&leaderType=${typeFilter}`;
    // }
    // config.url = dynamicQuery;
    axios(config)
      .then(async function (res) {
        let dumArray = [];
        let totalRound = await cuurentRound();
        for (let i = 1; i <= totalRound; i++) {
          let res1 = res?.data?.data.filter((item) => item?._id?.round === i);
          dumArray.push(res1);
        }
        setClaimsData(dumArray);
        // // console.log('dumArrray', dumArray)
        // setLoader(false);
      })
      .catch(function (error) {
        // setLoader(false);
      });
  };
  // useEffect(() => {
  //   axios
  //     .get("https://min-api.cryptocompare.com/data/price?fsym=ETH&tsyms=USD")
  //     .then((res) => {
  //       setUsdPrice(res?.data?.USD);
  //       // setEthUsd(res.data);
  //     });
  // }, []);
  useEffect(() => {
    if (user && user?.role != "admin") {
      getClaimsData();
    }
  }, [rend, user]);

  return (
    <>
      <section className="claim-section">
        <div className="custom-container">
          <div className="upper-heading">
            <h6>My Claims</h6>
          </div>
          <div className="bottom-tabs">
            <DataTable
              tomiPrice={tomiPrice}
              usdPrice={usdPrice}
              btcPrice={btcPrice}
              claimsData={claimsData}
              rend={rend}
              setRend={setRend}
            />
          </div>
        </div>
      </section>
      <Modal
        className="global-modal-scss claim-modal set-new-style-claim"
        show={show2}
        onHide={handleClose2}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Claim or Buy DOP</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="upper-div">
            <p>Total Amount</p>
            <h6>0.5 ETH + 1,000 USDT + 200 TOMI</h6>
          </div>
          <div className="twice-content">
            <div className="parent-inner">
              <div className="bottom-div">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="47"
                  height="47"
                  viewBox="0 0 47 47"
                  fill="none"
                >
                  <path
                    d="M23.192 23.2519C22.0548 23.2519 20.9431 23.5891 19.9975 24.2209C19.0519 24.8527 18.3149 25.7508 17.8797 26.8014C17.4445 27.8521 17.3306 29.0082 17.5525 30.1236C17.7744 31.239 18.322 32.2636 19.1261 33.0677C19.9303 33.8719 20.9548 34.4195 22.0702 34.6414C23.1856 34.8633 24.3418 34.7494 25.3924 34.3142C26.4431 33.879 27.3411 33.142 27.973 32.1964C28.6048 31.2508 28.942 30.1391 28.942 29.0019C28.942 27.4769 28.3362 26.0143 27.2579 24.936C26.1795 23.8577 24.717 23.2519 23.192 23.2519ZM23.192 30.9185C22.8129 30.9185 22.4424 30.8061 22.1272 30.5955C21.812 30.3849 21.5663 30.0856 21.4212 29.7353C21.2762 29.3851 21.2382 28.9997 21.3122 28.6279C21.3861 28.2562 21.5687 27.9146 21.8367 27.6466C22.1048 27.3785 22.4463 27.196 22.8181 27.122C23.1899 27.0481 23.5753 27.086 23.9255 27.2311C24.2757 27.3762 24.5751 27.6218 24.7857 27.937C24.9963 28.2522 25.1087 28.6228 25.1087 29.0019C25.1087 29.5102 24.9067 29.9977 24.5473 30.3572C24.1879 30.7166 23.7003 30.9185 23.192 30.9185ZM21.8312 18.8627C22.0135 19.0372 22.2284 19.174 22.4637 19.2652C22.6931 19.3666 22.9412 19.419 23.192 19.419C23.4428 19.419 23.6909 19.3666 23.9203 19.2652C24.1556 19.174 24.3706 19.0372 24.5528 18.8627L28.942 14.5502C29.3131 14.1791 29.5216 13.6758 29.5216 13.151C29.5216 12.6262 29.3131 12.123 28.942 11.7519C28.5709 11.3808 28.0676 11.1723 27.5428 11.1723C27.0181 11.1723 26.5148 11.3808 26.1437 11.7519L25.1087 12.8827L25.1087 6.00187C25.1087 5.49354 24.9067 5.00603 24.5473 4.64658C24.1879 4.28714 23.7003 4.08521 23.192 4.08521C22.6837 4.08521 22.1962 4.28714 21.8367 4.64658C21.4773 5.00603 21.2753 5.49354 21.2753 6.00187L21.2753 12.8827L20.2403 11.7519C19.8693 11.3808 19.366 11.1723 18.8412 11.1723C18.3164 11.1723 17.8131 11.3808 17.442 11.7519C17.0709 12.123 16.8625 12.6262 16.8625 13.151C16.8625 13.6758 17.0709 14.1791 17.442 14.5502L21.8312 18.8627ZM36.6087 29.0019C36.6087 28.6228 36.4963 28.2522 36.2857 27.937C36.0751 27.6218 35.7757 27.3762 35.4255 27.2311C35.0753 27.086 34.6899 27.0481 34.3181 27.122C33.9463 27.196 33.6048 27.3785 33.3367 27.6466C33.0687 27.9146 32.8861 28.2562 32.8122 28.6279C32.7382 28.9997 32.7762 29.3851 32.9212 29.7353C33.0663 30.0856 33.312 30.3849 33.6272 30.5955C33.9424 30.8061 34.3129 30.9185 34.692 30.9185C35.2003 30.9185 35.6879 30.7166 36.0473 30.3572C36.4067 29.9977 36.6087 29.5102 36.6087 29.0019ZM38.5253 15.5852L32.7753 15.5852C32.267 15.5852 31.7795 15.7871 31.4201 16.1466C31.0606 16.506 30.8587 16.9935 30.8587 17.5019C30.8587 18.0102 31.0606 18.4977 31.4201 18.8572C31.7795 19.2166 32.267 19.4185 32.7753 19.4185L38.5253 19.4185C39.0337 19.4185 39.5212 19.6205 39.8806 19.9799C40.2401 20.3394 40.442 20.8269 40.442 21.3352L40.442 36.6685C40.442 37.1769 40.2401 37.6644 39.8806 38.0238C39.5212 38.3833 39.0337 38.5852 38.5253 38.5852L7.85867 38.5852C7.35034 38.5852 6.86283 38.3833 6.50339 38.0238C6.14394 37.6644 5.94201 37.1769 5.94201 36.6685L5.94201 21.3352C5.94201 20.8269 6.14394 20.3394 6.50339 19.9799C6.86283 19.6205 7.35034 19.4185 7.85867 19.4185L13.6087 19.4185C14.117 19.4185 14.6045 19.2166 14.964 18.8572C15.3234 18.4977 15.5253 18.0102 15.5253 17.5019C15.5253 16.9935 15.3234 16.506 14.964 16.1466C14.6045 15.7871 14.117 15.5852 13.6087 15.5852L7.85867 15.5852C6.33368 15.5852 4.87114 16.191 3.79281 17.2693C2.71447 18.3477 2.10867 19.8102 2.10867 21.3352L2.10867 36.6685C2.10867 38.1935 2.71447 39.6561 3.79281 40.7344C4.87114 41.8127 6.33368 42.4185 7.85867 42.4185L38.5253 42.4185C40.0503 42.4185 41.5129 41.8127 42.5912 40.7344C43.6695 39.6561 44.2753 38.1935 44.2753 36.6685L44.2753 21.3352C44.2753 19.8102 43.6695 18.3477 42.5912 17.2693C41.5129 16.191 40.0503 15.5852 38.5253 15.5852ZM9.77534 29.0019C9.77534 29.381 9.88775 29.7515 10.0984 30.0667C10.309 30.3819 10.6083 30.6276 10.9585 30.7726C11.3088 30.9177 11.6941 30.9557 12.0659 30.8817C12.4377 30.8078 12.7792 30.6252 13.0473 30.3572C13.3153 30.0891 13.4979 29.7476 13.5718 29.3758C13.6458 29.004 13.6078 28.6186 13.4628 28.2684C13.3177 27.9182 13.072 27.6188 12.7568 27.4082C12.4417 27.1976 12.0711 27.0852 11.692 27.0852C11.1837 27.0852 10.6962 27.2871 10.3367 27.6466C9.97727 28.006 9.77534 28.4935 9.77534 29.0019Z"
                    fill="white"
                  />
                </svg>
                <h6>Claim Earnings</h6>
                <p>Your claims will be instantly transferred to your wallet</p>
              </div>
              <div className="twice-btn">
                <button
                  className="btn-add sccscscscsccs"
                  style={{ flex: "auto" }}
                >
                  Claim ALL NOW
                </button>
              </div>
            </div>
            <div className="parent-inner">
              <div className="bottom-div">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="47"
                  height="47"
                  viewBox="0 0 47 47"
                  fill="none"
                >
                  <path
                    d="M41.6608 8.87695L41.6608 27.5645C41.6608 28.5176 41.2821 29.4317 40.6082 30.1056C39.9342 30.7796 39.0201 31.1582 38.067 31.1582L20.9823 31.1582C21.3481 31.5776 21.5376 32.1223 21.5111 32.6782C21.4845 33.2341 21.2441 33.7582 20.84 34.1409C20.436 34.5236 19.8996 34.7353 19.343 34.7316C18.7865 34.728 18.253 34.5093 17.854 34.1213L14.2602 30.5275C14.0592 30.3272 13.8997 30.0891 13.7909 29.827C13.682 29.565 13.626 29.284 13.626 29.0002C13.626 28.7164 13.682 28.4354 13.7909 28.1733C13.8997 27.9112 14.0592 27.6731 14.2602 27.4728L17.854 23.8791C18.2509 23.4795 18.7884 23.2512 19.3515 23.2428C19.9146 23.2344 20.4587 23.4467 20.8674 23.8342C21.276 24.2217 21.5168 24.7537 21.5383 25.3165C21.5598 25.8793 21.3603 26.4281 20.9823 26.8457L37.3483 26.8457L37.3483 9.5957L18.6608 9.5957C18.6608 10.1676 18.4336 10.716 18.0292 11.1204C17.6248 11.5248 17.0764 11.752 16.5045 11.752C15.9327 11.752 15.3842 11.5248 14.9798 11.1204C14.5754 10.716 14.3483 10.1676 14.3483 9.5957L14.3483 8.87695C14.3483 7.92383 14.7269 7.00975 15.4009 6.33579C16.0748 5.66183 16.9889 5.2832 17.942 5.2832L38.067 5.2832C39.0201 5.2832 39.9342 5.66183 40.6082 6.33579C41.2821 7.00975 41.6608 7.92383 41.6608 8.87695ZM30.8795 34.752C30.3077 34.752 29.7592 34.9791 29.3548 35.3835C28.9505 35.7879 28.7233 36.3363 28.7233 36.9082L10.0358 36.9082L10.0358 19.6582L26.4017 19.6582C26.0359 20.0776 25.8465 20.6223 25.873 21.1782C25.8995 21.7341 26.14 22.2582 26.544 22.6409C26.9481 23.0236 27.4845 23.2353 28.041 23.2316C28.5975 23.228 29.1311 23.0093 29.5301 22.6213L33.1238 19.0275C33.3248 18.8272 33.4843 18.5891 33.5932 18.327C33.702 18.0649 33.758 17.7839 33.758 17.5002C33.758 17.2164 33.702 16.9354 33.5932 16.6733C33.4843 16.4112 33.3248 16.1731 33.1238 15.9728L29.5301 12.3791C29.1331 11.9795 28.5956 11.7512 28.0325 11.7428C27.4694 11.7344 26.9253 11.9467 26.5167 12.3342C26.108 12.7217 25.8672 13.2537 25.8457 13.8165C25.8242 14.3793 26.0238 14.9281 26.4017 15.3457L9.31702 15.3457C8.3639 15.3457 7.44982 15.7243 6.77586 16.3983C6.1019 17.0722 5.72327 17.9863 5.72327 18.9395L5.72327 37.627C5.72327 38.5801 6.1019 39.4942 6.77586 40.1681C7.44982 40.8421 8.3639 41.2207 9.31702 41.2207L29.442 41.2207C30.3951 41.2207 31.3092 40.8421 31.9832 40.1681C32.6571 39.4942 33.0358 38.5801 33.0358 37.627L33.0358 36.9082C33.0358 36.3363 32.8086 35.7879 32.4042 35.3835C31.9998 34.9791 31.4514 34.752 30.8795 34.752Z"
                    fill="white"
                  />
                </svg>
                <h6>Buy More $DOP</h6>
                <p>Use your claims to buy DOP at this round's price</p>
                <h5>*You won't get any commissions from this purchase.</h5>
              </div>
              <div className="twice-btn">
                <button
                  className="btn-add btn-style-new"
                  style={{ flex: "auto" }}
                  onClick={() => {
                    handleClose2();
                    setShow3(true);
                  }}
                >
                  Buy $Dop WITH CLAIMS
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="global-modal-scss claim-modal buydop-modal"
        show={show3}
        onHide={handleClose3}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Buy $DOP</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="buy-dop">
            <p className="para">
              You will be able to purchase $DOP with full or partial amount of
              your available claims. In case of partial amount, the remaining
              available claims will be sent to your wallet in the same
              transaction
            </p>
            <div className="twice-field">
              <div className="option-field">
                <div className="material-textfield">
                  <input type="number" placeholder="Amount" />
                  <label>Enter amount</label>
                </div>
              </div>
              <div class="dropdown">
                <button
                  class="dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <img
                    src="\assets\claim\eth.svg"
                    alt="img"
                    className="img-fluid"
                  />{" "}
                  ETH{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="8"
                    height="6"
                    viewBox="0 0 8 6"
                    fill="none"
                  >
                    <path
                      d="M7.81779 2.00495L5.9829 3.95384L4.86253 5.14989C4.38809 5.65381 3.61641 5.65381 3.14197 5.14989L0.181004 2.00495C-0.207694 1.5921 0.0723969 0.887832 0.615431 0.887832H3.82219H7.38336C7.93211 0.887832 8.20648 1.5921 7.81779 2.00495Z"
                      fill="white"
                    />
                  </svg>
                </button>
                <ul class="dropdown-menu">
                  <li>
                    <a class="dropdown-item" href="#">
                      <img
                        src="\assets\claim\eth.svg"
                        alt="img"
                        className="img=fluid"
                      />
                      USDT
                    </a>
                  </li>
                </ul>
              </div>
              {/* <div class="dropdown">
                <button
                  class="dropdown-toggle"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <img
                    src="\assets\tomi-icon.svg"
                    alt="img"
                    className="img-fluid"
                  />{" "}
                 TOMI
                 
                </button>
              </div> */}
            </div>
            <div className="bottom-content">
              <div className="textt">
                <p>Balance</p>
                <h6>(0.5 ETH + 1,000 USDT)</h6>
              </div>
              <div className="textt">
                <p>DOP Price</p>
                <h6>0.01</h6>
              </div>
              <div className="textt">
                <p>Total DOP</p>
                <h6>0.00</h6>
              </div>
            </div>
          </div>
          <div className="twice-btn">
            <button className="btn-add" style={{ flex: "auto" }}>
              go back
            </button>
            <button className="btn-add" style={{ flex: "auto" }}>
              Buy Dop
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default LeadersAdmin;
